export default "__VITE_ASSET__B4N5XJeJ__"